import { IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { PaymentStatus as PaymentStatusEnum } from "#graphql/supergraphEnums";
import { PaymentStatus } from "#graphql/supergraphTypes";
import { TextWithIconProps } from "../../TextWithIcon";
import { PositionStatusIcons, PositionStatusText } from "../types";

export const positionStatusUI = (status: PaymentStatus): TextWithIconProps => {
  let label: string;
  let iconType: IconType;
  let iconColor: Colors;

  switch (status) {
    case PaymentStatusEnum.Pending:
      label = PositionStatusText.PENDING;
      iconType = PositionStatusIcons.PENDING;
      iconColor = Colors.Neutral800;
      break;
    case PaymentStatusEnum.Processing:
      label = PositionStatusText.PROCESSING;
      iconType = PositionStatusIcons.PROCESSING;
      iconColor = Colors.Neutral800;
      break;
    case PaymentStatusEnum.Settled:
      label = PositionStatusText.SETTLED;
      iconType = PositionStatusIcons.SETTLED;
      iconColor = Colors.Success600;
      break;
    case PaymentStatusEnum.Failed:
      label = PositionStatusText.FAILED;
      iconType = PositionStatusIcons.FAILED;
      iconColor = Colors.Danger600;
      break;
    case PaymentStatusEnum.Canceled:
      label = PositionStatusText.CANCELED;
      iconType = PositionStatusIcons.CANCELED;
      iconColor = Colors.Danger600;
      break;
    default:
      label = "Unknown";
      iconType = "exclamation-circle";
      iconColor = Colors.Neutral800;
  }
  return { label, iconType, iconColor };
};
